
import React from 'react';
import { User } from 'lucide-react';

interface PersonalInfoSectionProps {
  headline?: string | null;
  location?: string | null;
}

const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({ headline, location }) => {
  return (
    <div className="flex items-start gap-4">
      <div className="bg-[#0EA5E9]/10 p-2 rounded-full">
        <User className="h-5 w-5 text-[#0EA5E9]" />
      </div>
      <div>
        <h3 className="text-sm font-medium text-gray-800">Personal Info</h3>
        <p className="text-sm text-gray-600">{headline || 'No headline set'}</p>
        <p className="text-sm text-gray-600">{location || 'No location set'}</p>
      </div>
    </div>
  );
};

export default PersonalInfoSection;
